"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPageInfo = exports.pageInfoSchema = exports.paginationQuerySchema = exports.MAX_PAGE_LIMIT = exports.DEFAULT_PAGE_LIMIT = void 0;
const zod_1 = require("zod");
exports.DEFAULT_PAGE_LIMIT = 50;
exports.MAX_PAGE_LIMIT = 100;
exports.paginationQuerySchema = zod_1.z.object({
    limit: zod_1.z.coerce
        .number()
        .int()
        .min(1)
        .max(exports.MAX_PAGE_LIMIT)
        .default(exports.DEFAULT_PAGE_LIMIT),
    cursor: zod_1.z.string().trim().min(1).max(4_096).optional(),
});
exports.pageInfoSchema = zod_1.z.object({
    hasNextPage: zod_1.z.boolean(),
    nextCursor: zod_1.z.string().nullable(),
});
exports.defaultPageInfo = {
    hasNextPage: false,
    nextCursor: null,
};
//# sourceMappingURL=pagination.js.map